import { handleActions } from 'redux-actions';

import { m } from '../utils';
import { deleteData } from '../utils/request';
import { removeFromBookings } from './data';
import { openDialog, closeDialog } from './alert';
import { CHANGE_BOOKING_DETAIL, LOAD_UPCOMING_SHIFT } from '../constants';

const initialState = {
  bookingDetail: [],
  upcomingShift: {},
};

/** ******************* ACTIONS ******************** */

export const loadUpcomingShift = (bookings = []) => {
  const nextBooking = bookings.find(b => m(b.end_time).isAfter(m()));
  return {
    type: [LOAD_UPCOMING_SHIFT],
    upcomingShifts: bookings.filter(b => m(b.date).isSame(m(nextBooking && nextBooking.date))),
  };
};

export const changeBookingDetail = bookings => ({
  type: [CHANGE_BOOKING_DETAIL],
  bookings,
});

export const cancelShift = bookingId => dispatch => {
  deleteData(`bookings/${bookingId}`)
    .then(() => dispatch(removeFromBookings(bookingId)))
    .then(() => dispatch(closeDialog()))
    .then(() => dispatch(openDialog('deleteSuccess')))
    .then(() => dispatch(changeBookingDetail([])));
};

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [LOAD_UPCOMING_SHIFT]: (state, { upcomingShifts }) => ({
      ...state,
      bookingDetail: upcomingShifts.map(upcomingShift => ({
        ...upcomingShift,
        startTime: upcomingShift.start_time,
        endTime: upcomingShift.end_time,
        isIn30Mins: m(upcomingShift.start_time).isBefore(m().add(30, 'minutes')),
        isUpcomingShift: true,
        vehicleClass: upcomingShift.vehicle_class,
      })),
      upcomingShift: upcomingShifts.length ? { startTime: upcomingShifts[0].start_time } : {},
    }),

    [CHANGE_BOOKING_DETAIL]: (state, { bookings }) => ({
      ...state,
      bookingDetail: bookings.map(booking => ({
        ...booking,
        isUpcomingShift: m(booking.startTime).isSame(m(state.upcomingShift.startTime)),
        isIn30Mins: m(booking.startTime).isBefore(m().add(30, 'minutes')),
      })),
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/dashboard.js